import { render, staticRenderFns } from "./lrUser.vue?vue&type=template&id=28e5f56d"
import script from "./lrUser.vue?vue&type=script&lang=js"
export * from "./lrUser.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports